import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { getApi } from '../api'

/**
 * Adds a type to the account's vocabulary. Names are free text — the engine accepts one that
 * already exists rather than handing back the existing type, so the caller must not treat a
 * duplicate as an error.
 */
export default () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      accountId,
      name,
      value,
    }: {
      accountId: number
      name: string
      value: number | null
    }) => {
      const { api, baseURL } = getApi()
      return api
        .post(
          `/api/v2/accounts/${accountId}/container-types`,
          { name, value },
          { baseURL, allow404: true },
        )
        .then((res) => res.data.data)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account-container-types'] })
    },
  })
}
